module.exports = __webpack_public_path__ + "media/images/partner-1-04c52141594774d3f3da01043a085ec1.png";